// extracted by mini-css-extract-plugin
export default {"logo":"LoginPage_logo__4RQUU"};